import { render, staticRenderFns } from "./TransferCostsReport.vue?vue&type=template&id=5337c450"
import script from "./TransferCostsReport.vue?vue&type=script&lang=js"
export * from "./TransferCostsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports